export const KEYS = {
    tab: 9,
    enter: 13,
    esc: 27,
    space: 32,
}
